import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Sidebar } from '../../../components/sidebar';
import { EditProfileModal, type Profile } from '../../profiles-tracking/components/edit-profile-modal';
import { profilesTrackingService } from '../../profiles-tracking/services';
import { homeService } from '../../home/services';
import { useEditProfileModal } from '../../../contexts/useEditProfileModal';
import { useUserStore, canEditSelectedProfile } from '../../../store/user';
import { ReviewsManager } from '../components/ReviewsManager';
import { profileIdDoUsuario } from '../services';
import { ReviewsContainer, MainContent } from './styles';

export const ReviewsPage: React.FC = () => {
  const { isOpen: isEditModalOpen, closeModal } = useEditProfileModal();
  const [profileData, setProfileData] = useState<Profile | null>(null);
  const { user } = useUserStore();
  const canEdit = canEditSelectedProfile(user);
  const profileId = profileIdDoUsuario(user?.businessProfiles?.[0]);

  // Dados reais do perfil (nome, categoria, cidade) para o editor, como na Home.
  useEffect(() => {
    if (!user || !profileId) return;
    let ativo = true;
    const base: Profile = {
      id: profileId,
      name: user.name || "",
      category: "Cliente",
      status: "active" as const,
      stats: { views: 0, clicks: 0, ranking: 0 },
    };
    setProfileData(base);
    homeService
      .getProfileDetails(profileId)
      .then((details) => {
        if (ativo && details) setProfileData({ ...base, ...(details as Profile) });
      })
      .catch(() => undefined);
    return () => {
      ativo = false;
    };
  }, [user, profileId]);

  const handleSaveProfile = async (updatedProfile: Profile) => {
    try {
      await profilesTrackingService.updateProfile(
        updatedProfile.id,
        updatedProfile,
      );
      setProfileData(updatedProfile);
      toast.success('Perfil atualizado com sucesso!');
    } catch (error) {
      toast.error('Erro ao atualizar perfil');
      console.error(error);
      throw error;
    }
  };

  return (
    <ReviewsContainer>
      <Sidebar />
      <MainContent>
        {profileId ? (
          <ReviewsManager profileId={profileId} canEdit={canEdit} />
        ) : (
          <div style={{ padding: '60px 20px', textAlign: 'center', color: '#5F6368' }}>
            Nenhum perfil selecionado. Escolha um perfil para ver as avaliações.
          </div>
        )}
      </MainContent>

      {/* Modal de Edição de Perfil */}
      <EditProfileModal
        isOpen={isEditModalOpen}
        profile={profileData}
        onClose={closeModal}
        onSave={handleSaveProfile}
        hideIATab={true}
      />
    </ReviewsContainer>
  );
};

export default ReviewsPage;
